import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import paytm from "../../images/home/client/paytm.svg";
import neosoft from "../../images/home/client/neosoft.svg";
import Toyota from "../../images/home/client/Toyota.svg";
import cybersiara from "../../images/home/client/cybersiara.svg";
import GifTap from "../../images/home/client/GifTap.png";

const ClientLogo = {
  nav: false,
  loop: true,
  margin: 70,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2200,
  autoplayTimeout: 2200,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
    },
    481: {
      items: 2,
    },
    576: {
      items: 3,
    },
    768: {
      items: 4,
    },
    992: {
      items: 6,
    },
  },
};

const partnerLogo = [
  {
    images: paytm,
  },
  {
    images: neosoft,
  },
  {
    images: Toyota,
  },
  {
    images: cybersiara,
  },
  {
    images: GifTap,
  },
];

const Client = () => {
  return (
    <>
      <section className="getClientSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-right">
                <h3>
                  Organizations Affiliated <span>With Us</span>
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <OwlCarousel className="owl-carousel owl-theme" {...ClientLogo}>
                {partnerLogo.map((each, i) => (
                  <div className="item" data-aos="zoom-in" key={i}>
                    <img src={each.images} alt="hire iOS developer" />
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Client;
